import { FC } from "preact/compat";
import { format } from "date-fns";
import { ExternalEventProps } from "./interfaces";
import ArrowRightIcon from "@material-design-icons/svg/outlined/arrow_right.svg";
import OpenInNewIcon from "@material-design-icons/svg/outlined/open_in_new.svg";

const ExternalEvent: FC<ExternalEventProps> = ({ external, upcomingId }) => (
    <div className="flex">
        {external.id === upcomingId && (
            <div className="w-6 min-w-6 fill-current text-sky-700">
                <ArrowRightIcon width="24" height="24" />
            </div>
        )}
        <div className="mb-2 flex w-full items-center justify-between gap-x-2 truncate rounded-full bg-calendar-light px-2 py-1 text-sm">
            <div className="flex items-center gap-x-2">
                <span>{format(external.start, "HH:mm")}</span>
                <span>{external.title}</span>
            </div>
            {external.meeting_url && (
                <a
                    href={external.meeting_url}
                    title="Join meeting"
                    target="_blank"
                    rel="noreferrer noopener nofollow"
                    className="flex items-center justify-center rounded-full p-1 transition duration-100 hover:bg-white/80"
                >
                    <OpenInNewIcon
                        width="16"
                        height="16"
                        className="fill-current"
                    />
                </a>
            )}
        </div>
    </div>
);

export default ExternalEvent;
